export default function ppcPhoneSwap (document, moduleHTML, appEventEmitter) {
  const telAnchors = Array.from(document.querySelectorAll('[href^="tel:"]'))
  const phoneRegex = /(1?(-?\d{3})-?)?(\d{3})(-?\d{4})/g
  const params = new URLSearchParams(window.location.search)
  const phoneQueryValue = params.get('phone')

  if (phoneQueryValue) {
    window.setTimeout(() => {
      telAnchors.forEach((telAnchor) => {
        // GTM adds the country code '+1' to swapped numbers tel: links
        // So if it isn't present in the link, proceed with backup swap
        const hasCountryCode = telAnchor.href.indexOf('+1') > -1
        if (!hasCountryCode) {
          telAnchor.href = `tel:${phoneQueryValue}`
          telAnchor.innerHTML = telAnchor.innerHTML.replace(phoneRegex, formatPhone(phoneQueryValue))
        }
      })
    }, 1000) // Wait 1s for GTM to run
  }

  function formatPhone (phoneNumber) {
    if (phoneNumber.length === 10) {
      return [
        phoneNumber.substring(0, 3),
        phoneNumber.substring(3, 6),
        phoneNumber.substring(6, 10)
      ].join('-')
    } else if (phoneNumber.length === 7) {
      return [
        phoneNumber.substring(0, 3),
        phoneNumber.substring(3, 8)
      ].join('-')
    } else {
      return phoneNumber
    }
  }
}
